import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import OptionsDropdown from '~/Common-Objects/UI/OptionsDropdown/OptionsDropdown'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import axios from '~/data/http/axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import PermissionChecker from '~/Classes/permissions'
import i18n from '~/i18n'
import copy from 'copy-to-clipboard'
import IgnoreDrawer from './ignore'
import DeleteTrackerDrawer from './DeleteTrackerDrawer'
import upsellImage from '~/assets/images/upsell/tracking-upsell.png'

@connect((store) => {
    return { site: store.siteMaster, permissionStore: store.permission }
})
class SiteTracking extends Component {
    constructor(props) {
        super(props)
        this.state = {
            trackers: [],
            loading: true,
            trackersData: [],
            showIgnored: false,
            newSiteUrl: '',
            newSiteIncSubDomains: false,
            finalNewSiteUrl: '',
            addingSite: false,
            addedSite: false,
            newSiteError: '',
            writeAccess: PermissionChecker('company', this.props.permissionStore.permissions, 'write')
        }

        this.getTrackers = this.getTrackers.bind(this)
        this.copyToClipboard = this.copyToClipboard.bind(this)
        this.toggleTrackerIgnore = this.toggleTrackerIgnore.bind(this)
        this.addNewSite = this.addNewSite.bind(this)
        this.deleteArchivedTracker = this.deleteArchivedTracker.bind(this)
    }

    componentDidMount() {
        this.getTrackers()
    }

    async getTrackers() {
        this.props.getAccount()
        let query = ''
        if (this.state.showIgnored) query = '?showIgnored=true'
        let response = await axios.get('/accountMaster/tracker' + query)
        var trackersData = response.data.Trackers.map((tracker) => {
            var ourDomain = tracker.host
            if (!tracker.host || !tracker.host.length) ourDomain = 'unknown'
            return {
                domain: {
                    headerValue: i18n.t('campaigns:sitetracking.trackingsites.domain'),
                    value: (
                        <a
                            onClick={() => this.props.history.push('/cp/trackers/' + tracker.id)}
                            style={{ fontWeight: '600' }}
                        >
                            {ourDomain}
                            {tracker.ignore ? ' (ARCHIVED)' : ''}
                        </a>
                    ),
                    orderBy: false
                },
                hits: {
                    headerValue: i18n.t('campaigns:sitetracking.trackingsites.hits'),
                    value: <span>{NumberFunctions.formatNumber(tracker.hits)}</span>,
                    orderBy: false,
                    align: 'center',
                    width: '100'
                },
                lastHit: {
                    headerValue: i18n.t('campaigns:sitetracking.trackingsites.lastHit'),
                    value: <span> {DateTimeFunctions.formatDateTime(tracker.lastHit)}</span>,
                    orderBy: false,
                    align: 'center',
                    width: '200'
                },
                optionsCol: {
                    headerValue: ' ',
                    value: (
                        <OptionsDropdown popWidth='150px'>
                            <ul>
                                <li>
                                    <a onClick={() => this.props.history.push('/cp/trackers/' + tracker.id)}>View</a>
                                </li>
                                {this.state.writeAccess && (
                                    <li>
                                        <a onClick={() => this.toggleTrackerIgnore(tracker)}>
                                            {tracker.ignore ? 'Unarchive' : 'Archive'}
                                        </a>
                                    </li>
                                )}
                                {this.state.writeAccess && tracker.ignore && (
                                    <li>
                                        <a onClick={() => this.deleteArchivedTracker(tracker)}>Delete</a>
                                    </li>
                                )}
                            </ul>
                        </OptionsDropdown>
                    ),
                    fixed: true,
                    width: 20
                }
            }
        })
        let trackers = response.data.Trackers
        this.setState({
            trackersData: trackersData,
            trackers: trackers,
            loading: false
        })
    }

    copyToClipboard(key) {
        this.setState({
            alertOpen: true,
            alertMessage: i18n.t('campaigns:sitetracking.trackingsites.copiedToClipboard')
        })
        copy(this.props.embedCode)
    }

    toggleIgnored() {
        this.setState(
            {
                showIgnored: !this.state.showIgnored
            },
            this.getTrackers
        )
    }

    toggleTrackerIgnore(tracker) {
        const drawer = (
            <IgnoreDrawer
                site={tracker}
                finish={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false))
                    this.getTrackers()
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawer, true, 400))
    }

    deleteArchivedTracker(tracker) {
        const drawer = (
            <DeleteTrackerDrawer
                tracker={tracker}
                finished={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false))
                    this.getTrackers()
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawer, true, 400))
    }

    trackedHost(includeSubDomains = this.state.newSiteIncSubDomains) {
        let newSiteUrl = (this.state.newSiteUrl || '')
            .toLowerCase()
            .replace('https://', '')
            .replace('http://', '')
            .replace('www.', '')
            .replace(' ', '')
            .replace(/^\*\./, '')
        if (includeSubDomains && newSiteUrl) newSiteUrl = '*.' + newSiteUrl
        return newSiteUrl
    }

    async addNewSite() {
        if (!this.props.account?.approved) {
            this.setState({
                addingSite: false,
                newSiteError: 'Approval is required to enable Site Tracking'
            })
            return
        }
        this.setState({ addingSite: true, newSiteError: '', addedSite: false })

        const includeSubDomains = this.state.newSiteIncSubDomains
        const baseHost = this.trackedHost(false)
        if (!baseHost || baseHost.length < 5) {
            this.setState({ newSiteError: 'Invalid URL', addingSite: false })
            return
        }

        if (baseHost.indexOf('.') < 0 && baseHost.indexOf(':') < 0) {
            this.setState({ newSiteError: 'Invalid URL', addingSite: false })
            return
        }
        if (baseHost.length > 254) {
            this.setState({ newSiteError: 'URL too long', addingSite: false })
            return
        }

        const newSiteUrl = includeSubDomains ? '*.' + baseHost : baseHost

        try {
            await axios.post('/accountMaster/tracker', { host: newSiteUrl })
            this.setState(
                {
                    newSiteUrl: '',
                    finalNewSiteUrl: '',
                    newSiteIncSubDomains: false,
                    addingSite: false,
                    addedSite: !this.state.trackers.length == 0
                },
                () => {
                    this.getTrackers()
                }
            )
        } catch (e) {
            this.setState({ newSiteError: e?.data?.error || 'Error adding site', addingSite: false })
        }
    }

    generateFinalUrl() {
        this.setState({ finalNewSiteUrl: this.trackedHost() })
    }

    siteTrackingDomainForm() {
        const hasTrackers = this.state.trackers && this.state.trackers.length > 0
        return (
            <div>
                {hasTrackers && (
                    <>
                        <h4 className='mar-b10'> {i18n.t('campaigns:sitetracking.trackingsites.addAnotherSite')}</h4>
                        <div className='mar-b25'>
                            {i18n.t('campaigns:sitetracking.trackingsites.addAnotherSiteDesc')}
                        </div>
                    </>
                )}

                <TextInput
                    label={i18n.t('campaigns:sitetracking.trackingsites.trackingCode')}
                    value={this.props.embedCode}
                    iconRight={<Icons icon='copyClipboard' onClick={this.copyToClipboard} />}
                    readOnly={true}
                    className='mar-b15'
                />
                <TextInput
                    label={i18n.t('campaigns:sitetracking.trackingsites.websiteUrl')}
                    outerStyle={{ flex: '1' }}
                    value={this.state.newSiteUrl}
                    placeholder='yoursite.com'
                    onChange={(e) => this.setState({ newSiteUrl: e.target.value }, this.generateFinalUrl)}
                    error={this.state.newSiteError}
                    outerClassName='mar-b15'
                />

                <CheckBox
                    name={'allowSubDomains'}
                    onChange={() => {
                        this.setState({ newSiteIncSubDomains: !this.state.newSiteIncSubDomains }, this.generateFinalUrl)
                    }}
                    checked={this.state.newSiteIncSubDomains}
                >
                    {i18n.t('campaigns:sitetracking.trackingsites.includeSubDomains')}
                </CheckBox>

                {this.state.finalNewSiteUrl && this.state.finalNewSiteUrl.length > 3 && (
                    <div className='mar-t15'>
                        <strong>URL to be tracked</strong>
                        <div>{this.state.finalNewSiteUrl}</div>
                    </div>
                )}

                <Button
                    text={i18n.t('campaigns:sitetracking.trackingsites.addSite')}
                    onClick={this.addNewSite}
                    tooltip={
                        !this.props.account?.approved
                            ? 'Approval is required to enable Site Tracking'
                            : !this.state.writeAccess
                              ? "You don't have permission to do this"
                              : ''
                    }
                    for={'addSiteBtn'}
                    disabled={!this.state.writeAccess || !this.props.account?.approved}
                    className={hasTrackers ? 'mar-t15' : 'button-primary mar-t15'}
                />
            </div>
        )
    }

    render() {
        if (this.state.loading) return <LoadingIcons iconType='2' />
        let allowed = this.props.tierAllowed?.allowed
        if (allowed && this.props.tierAllowed.allowedNumber === this.props.tierAllowed.currentNumber) {
            allowed = false
        }
        return (
            <>
                {(!this.state.trackers || this.state.trackers.length < 1) && (
                    <Paper className='paper-dotted'>
                        <div className='quickFlex' style={{ gap: 40, alignItems: 'center' }}>
                            <img
                                className='hide-xs'
                                src={upsellImage}
                                alt=''
                                style={{ width: '100%', maxWidth: 400, height: 'auto', borderRadius: 12 }}
                            />
                            <div style={{ flexGrow: 1, maxWidth: 640 }}>
                                <h2 style={{ marginBottom: 8 }}>
                                    {i18n.t('campaigns:sitetracking.trackingsites.introHeading')}
                                </h2>
                                <div style={{ marginBottom: 24 }}>
                                    <div style={{ color: 'var(--neutral-800)' }}>
                                        {i18n.t('campaigns:sitetracking.trackingsites.introContent')}
                                    </div>
                                    {this.props.site?.siteId === 1 && (
                                        <a
                                            className='quickFlex'
                                            style={{
                                                alignItems: 'center',
                                                gap: 2,
                                                marginTop: 12,
                                                width: 'fit-content'
                                            }}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='https://transpond.io/support/growing-your-audience/website-tracking'
                                        >
                                            {i18n.t('campaigns:sitetracking.trackingsites.learnMore')}
                                            <Icons icon='external' style={{ width: 20, height: 20 }} />
                                        </a>
                                    )}
                                </div>
                                {allowed && (
                                    <>
                                        {!this.state.addingSite &&
                                            !this.state.addedSite &&
                                            this.siteTrackingDomainForm()}
                                        {this.state.addingSite && <LoadingIcons iconType='2' />}
                                    </>
                                )}
                                {!allowed && (
                                    <TierLimitHolder
                                        type='Site Tracker'
                                        err={this.props.tierAllowed.err}
                                        tierName={this.props.tierAllowed.tierName}
                                        allowedNumber={this.props.tierAllowed.allowedNumber}
                                    />
                                )}
                            </div>
                        </div>
                    </Paper>
                )}
                {this.state.trackers && this.state.trackers.length > 0 && (
                    <Row>
                        <Column xs={12} sm={12} md={8}>
                            <Paper isLoading={this.state.loading}>
                                <h4 className='mar-b25'>
                                    {i18n.t('campaigns:sitetracking.trackingsites.yourTrackedSites')}
                                </h4>
                                <div className='mar-b25'>
                                    {i18n.t('campaigns:sitetracking.trackingsites.yourTrackedSitesIntro')}
                                </div>
                                <Toggle
                                    outerClassName='mar-b25'
                                    after='Show Archived'
                                    checked={this.state.showIgnored}
                                    onChange={this.toggleIgnored.bind(this)}
                                />
                                <div style={{ marginTop: 10 }}>
                                    <DataTable1
                                        noResultsTxt={i18n.t('campaigns:sitetracking.trackingsites.noWebsites')}
                                        tableData={this.state.trackersData}
                                        loadingData={false}
                                        width='100%'
                                        pageSize='100'
                                        hasCheckBoxes='no'
                                    />
                                </div>
                            </Paper>
                        </Column>

                        <Column xs={12} sm={12} md={4}>
                            <Row>
                                <Column xs={12} sm={12} md={12} margin={0}>
                                    {allowed && (
                                        <Paper className='primary' isLoading={this.state.loading}>
                                            {!this.state.addingSite &&
                                                !this.state.addedSite &&
                                                this.siteTrackingDomainForm()}
                                            {this.state.addingSite && <LoadingIcons iconType='2' />}

                                            {this.state.addedSite && (
                                                <div>
                                                    <h4 className='mar-b25'>
                                                        {i18n.t('campaigns:sitetracking.trackingsites.siteAdded')}
                                                    </h4>
                                                    <div className='mar-b15'>
                                                        {i18n.t('campaigns:sitetracking.trackingsites.siteAddedDesc')}
                                                    </div>
                                                    <Button
                                                        text={i18n.t('campaigns:sitetracking.trackingsites.finish')}
                                                        onClick={() => {
                                                            this.setState({ addedSite: false })
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </Paper>
                                    )}
                                    {!allowed && (
                                        <TierLimitHolder
                                            type='Site Tracker'
                                            err={this.props.tierAllowed.err}
                                            tierName={this.props.tierAllowed.tierName}
                                            allowedNumber={this.props.tierAllowed.allowedNumber}
                                        />
                                    )}
                                </Column>
                                <Column xs={12} sm={12} md={12} margin={0}>
                                    <Paper isLoading={this.state.loading}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start'
                                            }}
                                        >
                                            <Icons
                                                icon='cog'
                                                className='mar-r15'
                                                style={{ width: 30, height: 30 }}
                                            />
                                            <div>
                                                <h4 className='mar-b10'>
                                                    {i18n.t('campaigns:sitetracking.trackingsites.moreOptions')}
                                                </h4>
                                                Developer tools to extend and progamatically manipulate Site Tracking.
                                            </div>
                                            <Button
                                                style={{ flex: '0 0 100px' }}
                                                text='Show'
                                                iconRight={<Icons icon={'arrowRight'} />}
                                                onClick={() => {
                                                    this.props.history.push('/cp/trackers/advanced')
                                                }}
                                            />
                                        </div>
                                    </Paper>
                                </Column>
                                <Column xs={12} sm={12} md={12} margin={0}>
                                    <Paper isLoading={this.state.loading}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start'
                                            }}
                                        >
                                            <Icons
                                                icon='cloudUpload'
                                                className='mar-r15'
                                                style={{ width: 30, height: 30 }}
                                            />
                                            <div>
                                                <h4 className='mar-b10'>Events</h4>
                                                Enrich your data by triggering events such as Registrations and Payments
                                                when your customers interact with your website.
                                            </div>
                                            <Button
                                                style={{ flex: '0 0 100px' }}
                                                text='Show'
                                                iconRight={<Icons icon={'arrowRight'} />}
                                                onClick={() => {
                                                    this.props.history.push('/cp/trackers/events')
                                                }}
                                            />
                                        </div>
                                    </Paper>
                                </Column>
                            </Row>
                        </Column>
                    </Row>
                )}
                <SnackBar
                    message={this.state.alertMessage}
                    open={this.state.alertOpen}
                    autoclose={true}
                    dismiss={() => this.setState({ alertOpen: false })}
                />
            </>
        )
    }
}

export default SiteTracking
